import { render } from "./Carousel.vue?vue&type=template&id=9de6b4f6&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&id=9de6b4f6&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-9de6b4f6"
/* custom blocks */
import block0 from "./Carousel.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script